import { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { Fragment } from "react";
import { Stack, Typography, Autocomplete, TextField, IconButton, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';




export const FormVariable = ({ productList, setProducts, dataProduct }) => {


    const [inputFields, setInputFields] = useState([
        { id: uuidv4(), product: '', amount: '', priceProduct: '' },
    ]);

    useEffect(() => {
        if (productList !== '') {
            setInputFields(JSON.parse(productList));
            setProducts(JSON.parse(productList))
        }
    }, [productList, setProducts])

    const handleChangeInput = (id, event) => {
        const newInputFields = inputFields.map(i => {
            if (id === i.id) {
                i[event.target.name] = event.target.value
            }
            return i;
        })
        setInputFields(newInputFields);
        setProducts(inputFields)
    }

    const handleAddFields = () => {
        setInputFields([...inputFields, { id: uuidv4(), product: '', amount: '', priceProduct: '' }])
    }

    const handleRemoveFields = id => {
        const values = [...inputFields];
        values.splice(values.findIndex(value => value.id === id), 1);
        setInputFields(values);
        setProducts(values)
    }
    

    return (
        <Fragment>
            {
                inputFields.length > 0
                    ?
                    <Stack flexDirection='row' width='100%' justifyContent='space-around' flexWrap='wrap'  >
                        <Stack width='90%'>
                            <Typography textAlign='center' mb='2rem' variant="subtitle" color="primary">Servicios</Typography>
                        </Stack>
                        <Stack width='100%' alignItems='center' >
                            {inputFields.map(inputField => (
                                <Stack width='95%' alignItems='center' gap={2} key={inputField.id} flexDirection='row' justifyContent='space-between'>
                                    {dataProduct &&
                                        <Autocomplete
                                            disablePortal
                                            options={dataProduct?.filter(d => d.type === 'Servicio').map((d) => d.product).concat('') || ['Cargando productos']}
                                            sx={{ width: '160px' }}
                                            size='small'
                                            renderInput={(params) => <TextField name='product'{...params}
                                                label="Producto" variant="standard" required />}
                                            onSelect={event => handleChangeInput(inputField.id, event)}
                                            value={dataProduct?.filter(d => d.type === 'Servicio').map((d) => d.product).concat('').includes(inputField.product) ? inputField.product : ''}
                                        />}
                                    <TextField
                                        name="amount"
                                        label="Cantidad"
                                        variant="standard"
                                        value={inputField.amount}
                                        onChange={event => handleChangeInput(inputField.id, event)}
                                        type="number"
                                        InputProps={{ inputProps: { min: 0 } }}
                                        sx={{ width: '100px' }}
                                        required
                                    />
                                    <TextField
                                        name="priceProduct"
                                        label="Precio/ud"
                                        variant="standard"
                                        value={inputField.priceProduct}
                                        onChange={event => handleChangeInput(inputField.id, event)}
                                        type="number"
                                        InputProps={{ inputProps: { inputMode: "decimal" } }}
                                        sx={{ width: '100px' }}
                                        required
                                    />
                                    <IconButton onClick={() => handleRemoveFields(inputField.id)}>
                                        <DeleteIcon color='primary' />
                                    </IconButton>
                                    <IconButton
                                        onClick={handleAddFields}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </Stack>
                            ))}
                        </Stack>
                    </Stack>
                    :
                    <Button onClick={handleAddFields}>Añadir Servicios</Button>
            }
        </Fragment>
    )
}